export const ADD_CONSTRUCTOR: 'ADD_CONSTRUCTOR' = 'ADD_CONSTRUCTOR';
export const ADD_BUN: 'ADD_BUN' = 'ADD_BUN';
export const UPDATE_BUN: 'UPDATE_BUN' = 'UPDATE_BUN';
export const REMOVE_CONSTRUCTOR: 'REMOVE_CONSTRUCTOR' = 'REMOVE_CONSTRUCTOR';
export const CLEAR_CONSTRUCTOR: 'CLEAR_CONSTRUCTOR' = 'CLEAR_CONSTRUCTOR';
export const UPDATE_CONSTRUCTOR: 'UPDATE_CONSTRUCTOR' = 'UPDATE_CONSTRUCTOR';
